export default "__VITE_ASSET__CMUvzAQf__"